/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AgentTour_tour = {
    readonly thumbnailURL: string;
    readonly title: string;
    readonly listingLink: string;
    readonly description: string;
    readonly agentProfile: {
        readonly " $fragmentRefs": FragmentRefs<"TourAgentInfo_tour">;
    } | null;
    readonly viewingSessionRequest: {
        readonly rtcToken: string;
        readonly signalingToken: string;
        readonly appId: string;
        readonly viewingSessionUserId: number;
        readonly expireTime: number;
    };
    readonly id: string;
    readonly " $fragmentRefs": FragmentRefs<"TourPreviewMarkers_tour" | "TourPlayerCanvas_tour">;
    readonly " $refType": "AgentTour_tour";
};
export type AgentTour_tour$data = AgentTour_tour;
export type AgentTour_tour$key = {
    readonly " $data"?: AgentTour_tour$data;
    readonly " $fragmentRefs": FragmentRefs<"AgentTour_tour">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./AgentTourTodoRefetchQuery.graphql.ts'),
      "identifierField": "id"
    }
  },
  "name": "AgentTour_tour",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbnailURL",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "listingLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AgentProfile",
      "kind": "LinkedField",
      "name": "agentProfile",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TourAgentInfo_tour"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ViewingSessionRequest",
      "kind": "LinkedField",
      "name": "viewingSessionRequest",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rtcToken",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "signalingToken",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "appId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewingSessionUserId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "expireTime",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TourPreviewMarkers_tour"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TourPlayerCanvas_tour"
    }
  ],
  "type": "Tour",
  "abstractKey": null
};
(node as any).hash = '73ab80a1d5d8474ee054c0c2a44941f1';
export default node;
